import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { AccountService } from './account-service.interface';

export const DataAccessAccountService = new InjectionToken<AccountService>(
  'AccountService',
);

export interface AccountServiceUseClass extends ClassSansProvider {
  useClass: Type<AccountService>;
}

export interface AccountServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => AccountService;
}

export type AccountServiceProvider =
  | AccountServiceUseFactory
  | AccountServiceUseClass;

export function provideDataAccessAccountService(
  config: AccountServiceProvider,
) {
  return {
    provide: DataAccessAccountService,
    ...config,
  };
}
